import { render, staticRenderFns } from "./CredenciamentoAtualizacaoAcoesDocumentos.vue?vue&type=template&id=e6a6fd96"
import script from "./CredenciamentoAtualizacaoAcoesDocumentos.vue?vue&type=script&lang=js"
export * from "./CredenciamentoAtualizacaoAcoesDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports